import {useDebugValue} from 'react';

import {undef} from '../../../utils';

import {useTranslations} from './';

const defaultTranslations = {
    titleMessage: 'Search',
    closeButtonLabel: 'Close',
    secondaryActionLabel: undef
};

function useDetailsModalTranslations(props) {
    const {
        detailsModalTranslations: propsTranslations
    } = props;

    const {
        translations
    } = useTranslations(defaultTranslations, propsTranslations);

    const result = {
        translations
    };

    useDebugValue(result);

    return result;
}

export {useDetailsModalTranslations};
